import React from 'react';
import { ReactComponent as LogoSVG } from 'assets/img/logo.svg';
import { useNavigate, useLocation } from 'react-router-dom';
import 'styles/footer.scss';

const BottomInfoBlock = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const goTo = (e, path) => {
    e.preventDefault();
    if (location.pathname === path && path === '/gift-card') {
      window.__reset_gift_card__();
    }
    navigate(path);
  };

  return (
    <section className="bg-gray py-4">
      <div className="footer container d-flex flex-wrap">
        <div className="col-lg-3 col-md-6 text-black d-flex flex-column justify-content-lg-between">
          <p className="text-primary-color">
            <LogoSVG />
          </p>
          <p className="text-primary-color">
            (213) 831-5758
            <br /> contact@nuveta.com
          </p>
        </div>

        <div className="col-lg-3 col-md-6">
          <h4 className="text-primary-color font-weight-bold text-lg-left text-center">
            RESOURCES
          </h4>

          <ul className="mt-3">
            <li className="text-lg-left text-center">
              <a
                className="text-primary-color"
                onClick={e => goTo(e, '/terms')}
                href="/terms"
              >
                Terms Of Use
              </a>
            </li>
            <li className="text-lg-left text-center">
              <a
                className="text-primary-color"
                onClick={e => goTo(e, '/contact-us')}
                href="/contact-us"
              >
                Contact Us
              </a>
            </li>
            <li className="text-lg-left text-center">
              <a
                className="text-primary-color"
                onClick={e => goTo(e, '/privacy-policy')}
                href="/"
              >
                Privacy Policy
              </a>
            </li>
            <li className="text-lg-left text-center">
              <a
                className="text-primary-color"
                onClick={e => goTo(e, '/faq')}
                href="/faq"
              >
                FAQ
              </a>
            </li>
          </ul>
        </div>

        <div className="col-lg-3 col-md-6">
          <h4 className="text-primary-color font-weight-bold">COMPANY</h4>

          <ul className="mt-3">
            <li>
              <a
                className="text-primary-color"
                onClick={e => goTo(e, '/gift-card')}
                href="/gift-card"
              >
                Gift Card
              </a>
            </li>
            <li>
              <a
                className="text-primary-color"
                onClick={e => goTo(e, '/about-us')}
                href="/about-us"
              >
                About Us
              </a>
            </li>
            <li>
              <a
                className="text-primary-color"
                onClick={e => goTo(e, '/certificates')}
                href="/certificates"
              >
                Certificates
              </a>
            </li>
          </ul>
        </div>
        <div className="col-lg-3 col-md-6 text-md-right d-flex flex-column justify-content-between">
          <p className="text-center">
            <a
              onClick={e => goTo(e, '/gift-card')}
              href="/"
              className="btn btn-secondary font-weight-bold text-nowrap"
            >
              BUY GIFT CARD
            </a>
          </p>
          <div className="d-flex justify-content-center gap-3 pb-3">
            <a href="mailto:contact@nuveta.com">
              <svg
                width="50"
                height="50"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 34.05 34.05"
              >
                <path
                  d="M8.5,10.5 L25.5,10.5 C26.33,10.5 27,11.17 27,12 L27,22 C27,22.83 26.33,23.5 25.5,23.5 L8.5,23.5 C7.67,23.5 7,22.83 7,22 L7,12 C7,11.17 7.67,10.5 8.5,10.5 Z M8.5,12 L17,17.5 L25.5,12 M7,12 L17,18 L27,12"
                  fill="none"
                  stroke="#00598f"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
                <rect
                  x=".5"
                  y=".5"
                  width="33.05"
                  height="33.05"
                  rx="12"
                  ry="12"
                  fill="#00598f"
                  stroke="#00598f"
                  strokeMiterlimit="10"
                  opacity="0.1"
                />
              </svg>
            </a>
            <a
              href="https://www.instagram.com/nuveta.us/"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                width="50"
                height="50"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 34.05 34.05"
              >
                <path
                  fill="#00598f"
                  d="M27.5,12.72v8.42l-.09,1c-.56,4.01-3.23,5.25-6.96,5.3-.07,0-.18-.03-.22.04-2.1-.04-4.2.06-6.29,0-2.34-.07-4.62-.33-6.11-2.37-1.05-1.44-1.1-2.88-1.17-4.6-.09-2.6-.19-5.73.04-8.3.34-3.69,2.62-5.41,6.19-5.62,2.38-.14,5.04-.07,7.44,0,.5.02,1.01,0,1.51.04,3.59.32,5.48,2.57,5.66,6.09ZM13.39,8.48c-3.41.13-4.72,1.28-4.86,4.75-.1,2.55-.09,5.26.04,7.81.16,3.09,1.3,4.32,4.43,4.52,2.32.14,4.94.07,7.28,0,1.65-.06,3.19,0,4.36-1.37,1.02-1.18.93-2.67.98-4.13.07-2.28.13-4.76,0-7.03-.2-3.44-1.63-4.45-4.96-4.56-2.32-.08-4.95-.08-7.27.01Z"
                />
                <path
                  fill="#00598f"
                  d="M16.46,11.67c5.37-.48,8.12,6.01,4.07,9.47-3.25,2.77-8.35.68-8.81-3.54-.31-2.86,1.82-5.68,4.73-5.93ZM16.66,13.55c-2.42.23-3.79,2.96-2.67,5.1,1.13,2.16,4.17,2.5,5.74.63,2.05-2.44.1-6.04-3.07-5.73Z"
                />
                <path
                  fill="#00598f"
                  d="M22.38,10.2c1.8-.3,2.07,2.26.47,2.47-1.68.23-1.92-2.23-.47-2.47Z"
                />
                <rect
                  x=".5"
                  y=".5"
                  width="33.05"
                  height="33.05"
                  rx="12"
                  ry="12"
                  fill="#00598f"
                  stroke="#00598f"
                  strokeMiterlimit="10"
                  opacity="0.1"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BottomInfoBlock;
